import { NewRecordLauncher } from './create/NewRecordLauncher';
import type { INewRecordDialogProps } from './INewRecordDialogProps';

/**
 * Створення запису за подією dialogOpened newRecord (UIUX forms/form-variants; прототип v4 createRecord): кнопки «+ Створити …», «+ Нове …»
 * і «+» доріжки дошки відкривають повну форму нового запису в режимі редагування (без діалогу; «Зберегти» створює, «Скасувати» відкидає).
 * Дочірні завдання й рядки підтаблиць створюються на місці (NewChildRow, useSubTableAdd).
 */
export function NewRecordDialog(props: INewRecordDialogProps) {
  return <NewRecordLauncher {...props} />;
}
